import employeeapi from "../../../../services/employee";

export const fetchDataEntriesApi = async (year, month, dataType) => {
  const response = await employeeapi.get(`DataEntries/by-branch?year=${year}&month=${month}&dataType=${dataType}`);
  return response.data;
};

export const createBulkDataEntriesApi = async (items) => {
  const response = await employeeapi.post("DataEntries/Bulk", { items });
  return response.data;
};

export const updateDataEntryApi = async (id, data) => {
  const response = await employeeapi.put(`DataEntries/${id}`, data);
  return response.data;
};

export const deleteDataEntryApi = async (id) => {
  const response = await employeeapi.delete(`DataEntries/${id}`);
  return response.data;
};
